import { render, staticRenderFns } from "./EnergyInsights.vue?vue&type=template&id=397cebb4&scoped=true"
import script from "./EnergyInsights.vue?vue&type=script&lang=js"
export * from "./EnergyInsights.vue?vue&type=script&lang=js"
import style0 from "./EnergyInsights.vue?vue&type=style&index=0&id=397cebb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397cebb4",
  null
  
)

export default component.exports